<template>
  <div class="base_setting tab_content c-custom_base_setting" style="padding: 20px 25px">
    <div class="base_color_setting">
      <span class="title_words">{{$t('view_left_sidebar_page_setting_base_setting_244')}}</span>
      <div class="right">
        <span
          class="base_color"
          v-for="item in colorList"
          :key="item.name"
          :style="{ backgroundColor: item.color }"
          :class="{ selected: $store.state.myRender.common.theme_color_type === item.key }"
          @click="change_theme_color(item.color,item.key)"
        ></span>
        <div class="f_color_picker">
          <div class="show_btn color_cube_wrap"
              :class="{ selected: $store.state.myRender.common.theme_color_type == 'color_picker' }"
          >
            <div class="color_cube"></div>
            <my_color
              style="position: absolute;width: 100%;height: 100%;top: 0;opacity: 0;"
              titleWidth="0"
              title=""
              :color.sync="themeColor"
            ></my_color>
          </div>
        </div>
      </div>
    </div>
    <div class="content_show">
      <div class="row_layout_display_area">
        <div class="row_layout_display_wrap">
          <el-popover popper-class="hide_popover" placement="top" trigger="hover"
                      :content="$store.state.myRender.common.header_display === 'true' ? $t('view_left_sidebar_page_setting_base_setting_245') : $t('view_left_sidebar_page_setting_base_setting_246')"
                      transition="zoom">
            <div
              slot="reference"
              class="header_row_display jz_tooltip"
              :class="{ row_display_hidden: $store.state.myRender.common.header_display === 'false' }"
              @click="toggle_header"
            >
              <i
                class="func_row_edit_icon"
                v-if="$store.state.myRender.common.header_display === 'true'"
                @click.stop="set_header"
              ></i>
              <span class="func_row_edit_text">{{$t('view_left_sidebar_page_setting_base_setting_247')}}</span>
            </div>
          </el-popover>
          <div class="content_row_display">
            <i></i>
            <span>{{$t('view_left_sidebar_page_setting_base_setting_248')}}</span>
          </div>
          <el-popover popper-class="hide_popover" placement="top" trigger="hover"
                      :content="$store.state.myRender.common.footer_display === 'true' ? $t('view_left_sidebar_page_setting_base_setting_245') : $t('view_left_sidebar_page_setting_base_setting_246')"
                      transition="zoom">
            <div
              slot="reference"
              class="footer_row_display jz_tooltip"
              :class="{ row_display_hidden: $store.state.myRender.common.footer_display === 'false' }"
              @click="toggle_footer"
            >
              <i
                class="func_row_edit_icon"
                @click.stop="set_footer"
                v-if="$store.state.myRender.common.footer_display === 'true'"
              ></i>
              <span class="func_row_edit_text">{{$t('view_left_sidebar_page_setting_base_setting_249')}}</span>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="body_background">
      <my_background
        titleWidth="40"
        :title="$t('widgets_basic_button_edit_444')"
        :radioValue.sync="body_background.radio_val"
        :bgType.sync="body_background.custom.type"
        :imgUrl.sync="body_background.custom.img"
        :imgScale.sync="body_background.custom.img_scale"
        :tileEffect.sync="body_background.custom.tile_effect"
        :imgPos.sync="body_background.custom.background_position"
        :colorValue.sync="body_background.custom.color"
        @imgScaleChange="
          img_scale => {
            let options = this.$store.state.options.backGroundImageList;
            body_background.custom.background_size = options[img_scale].background_size;
            body_background.custom.background_repeat = options[img_scale].background_repeat;
            body_background.custom.background_position = options[img_scale].background_position;
          }
        "
        @tileEffectChange="
          tile_effect => {
            let options = this.$store.state.options.backGroundImageList;
            body_background.custom.background_size = options[tile_effect].background_size;
            body_background.custom.background_repeat = options[tile_effect].background_repeat;
            body_background.custom.background_position = options[tile_effect].background_position;
          }
        "
      ></my_background>

      <my_radio
        :title="$t('view_left_sidebar_page_setting_base_setting_250')"
        v-if="$store.state.myRender.private.fixed_background_isOpen"
        hiddenIsShow="false"
        titleWidth="65"
        :selectValue.sync="$store.state.myRender.private.fixed_background_isOpen"
        :option="$store.state.options.areaCodeList"
      ></my_radio>

      <my_radio
        :title="$t('view_left_sidebar_page_setting_base_setting_251')"
        hiddenIsShow="false"
        titleWidth="65"
        iconIsShow="left"
        :tips="adaptWidthTip"
        :selectValue.sync="$store.state.myRender.common.adaptWidth.isOpen"
        :option="$store.state.options.adaptWidthIsOpen"
      ></my_radio>
      <my_radio
        v-if="$store.state.myRender.common.adaptWidth.isOpen==='true'"
        title=" "
        hiddenIsShow="false"
        titleWidth="65"
        :selectValue.sync="$store.state.myRender.common.adaptWidth.radioVal"
        :option="$store.state.options.adaptWidth"
        class="base_setting_my_radio"
      ></my_radio>
      <my_slider
        v-if="$store.state.myRender.common.adaptWidth.isOpen==='true' && $store.state.myRender.common.adaptWidth.radioVal==='custom'"
        class="slider-wrapper base_setting_slider_wrapper"
        titleWidth="45"
        title=" "
        :value.sync="$store.state.myRender.common.adaptWidth.customVal"
        :min="740"
        :max="1440"
      ></my_slider>

    </div>
  </div>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: 'base_setting',
  data() {
    return {
      colorList: this.$store.state.options.baseColor,
      body_background: this.$store.state.myRender.common.body_background,
      themeColor: this.$store.state.myRender.common.theme_color
    }
  },
  computed: {
    adaptWidthTip() {
      return i18n.t('view_left_sidebar_page_setting_base_setting_252', [this.$store.state.myRender.common.adaptWidth.val])
    }
  },
  watch: {
    themeColor(val) {
      this.change_theme_color(val, 'color_picker')
    },
    '$store.state.myRender.common.adaptWidth.customVal'(val) {
      this.$store.state.myRender.common.adaptWidth.val = val
    },
    '$store.state.myRender.common.adaptWidth.radioVal'(val) {
      if (val === 'custom') {
        this.$store.state.myRender.common.adaptWidth.val = this.$store.state.myRender.common.adaptWidth.customVal
      } else {
        this.$store.state.myRender.common.adaptWidth.val = val
      }
    }
  },
  methods: {
    change_theme_color(val, themeColorType) {
      this.$store.commit('myRender/SET_theme_color_type', themeColorType);
      this.$store.commit('myRender/set_theme_color', val);
      this.templet.global_color_for_module()
    },
    toggle_footer() {
      if (this.$store.state.myRender.common.footer_display === 'true') {
        this.$store.commit('myRender/set_footer_display', 'false')
      } else if (this.$store.state.myRender.common.footer_display === 'false') {
        this.$store.commit('myRender/set_footer_display', 'true')
      }

      this.$nextTick(() => {
        const h = $('html').height();
        $('html,body').animate({
          scrollTop: h * 2 + 'px'
        }, 100);
      })
    },
    toggle_header() {
      if (this.$store.state.myRender.common.header_display === 'true') {
        this.$store.commit('myRender/set_header_display', 'false')
      } else if (this.$store.state.myRender.common.header_display === 'false') {
        this.$store.commit('myRender/set_header_display', 'true')
      }
      this.$nextTick(() => {
        $('html,body').animate({
          scrollTop: 0
        }, 100);
      })
    },
    set_header() {
      this.$store.commit('left_sidebar/set_style_active', 'header')
    },
    set_footer() {
      this.$store.commit('left_sidebar/set_style_active', 'footer')
    }
  }
}
</script>

<style lang="scss" scoped>
.base_setting {
  .base_color_setting {
    display: flex;

    .title_words {
      display: inline-block;
      padding: 0;
      min-width: 55px;
      line-height: 20px;
      vertical-align: middle;
      font-size: 13px;
      color: #333;
      text-align: right;
      margin-right:5px;
    }

    .base_color {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 6px;
      margin-bottom: 6px;
      border-radius: 50%;
      vertical-align: middle;
      transition: transform 0.2s;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        border-radius: 5px;
        transform: rotate(45deg);
      }

      &.selected {
        border-radius: 5px;
        transform: rotate(45deg);
      }
    }

    .f_color_picker {
      position: relative;
      box-sizing: border-box;
      width: 20px;
      height: 20px;
      vertical-align: baseline;
      border: none;
      display: inline-block;
      border-radius: 50%;
      transition: transform 0.2s;

      /deep/ {
        .color_block {
          margin: 0 !important;
        }
      }

      .color_cube {
        width: 100%;
        height: 100%;
        background-image: url(~@/assets/image/component.png) !important;
        background-position: -456px -185px !important;
      }

      &:hover .color_cube_wrap, .selected {
        border-radius: 5px !important;
        transform: rotate(45deg);
      }

      .color_cube_wrap {
        position: relative;
        width: 25px;
        height: 25px;
        cursor: pointer;
        overflow: hidden;
      }

      .show_btn.color_cube_wrap {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        overflow: hidden;
        cursor: pointer;
      }
    }
    .right{
      display: flex;
      flex-wrap: wrap;
    }
  }

  .content_show {
    .row_layout_display_area {
      width: 100%;
      margin: 20px auto;

      .row_layout_display_wrap {
        width: 100%;
        margin: 0 auto;
        color: #fff;
        font-size: 13px;
        text-align: center;

        .header_row_display,
        .footer_row_display {
          box-sizing: border-box;
          width: 100%;
          height: 44px;
          line-height: 40px;
          background: #0078d7;
          cursor: pointer;

          &.row_display_hidden {
            color: #bababa;
            background: #f8f8f8;
          }

          &.row_display_hidden__disabled {
            cursor: not-allowed;
          }

          .func_row_edit_icon {
            display: inline-block;
            margin-right: 5px;
            width: 16px;
            height: 16px;
            vertical-align: middle;
            background-image: url(~@/assets/image/cssSprite.png);
            background-repeat: no-repeat;
            background-position: -188px -202px;
            cursor: pointer;
          }

          .func_row_edit_text {
            vertical-align: middle;
          }
        }

        .footer_row_display {
          margin-top: 8px;
        }

        .content_row_display {
          box-sizing: border-box;
          width: 100%;
          height: 94px;
          line-height: 92px;
          border: 1px dashed #bababa;
          margin-top: 8px;
          color: #bababa;
          background: #f8f8f8;
        }
      }
    }
  }

  &.c-custom_base_setting {
    .base_color_setting {
      .title_words {
        flex-shrink: 0;
      }
    }
  }
}
</style>

<style lang="scss">
.base_setting {
  .pull_down_content > div {
    margin-left: 0 !important;
  }

  .my_radio_layer {
    margin-left: 0;
    margin-right: 0;
  }
}

.hide_popover {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/view/left_sidebar/page_setting/base_setting.vue